import http from "@/lib/http/client"
import { Role, Invitation, TeamMember, InviteTeamMemberInput, InviteTeamMemberResponse } from "@/types/api"

export const listRoles = async (): Promise<Role[]> => {
  const res = await http.get(`/teams/roles`)
  return res.data
}

export const listInvitations = async (): Promise<Invitation[]> => {
  const res = await http.get(`/teams/invitations`)
  return res.data
}

export const listMembers = async (): Promise<TeamMember[]> => {
  const res = await http.get(`/teams`)
  return res.data
}

export const inviteTeamMember = async (data: InviteTeamMemberInput): Promise<InviteTeamMemberResponse> => {
  const res = await http.post(`/teams/invite`, data)
  return res.data
}

export const resendInvitation = async (email: string): Promise<{ message: string }> => {
  const res = await http.post(`/teams/invitations/resend`, { email })
  return res.data
}

export const cancelInvitation = async (email: string): Promise<{ message: string }> => {
  const res = await http.delete(`/teams/invitations/${encodeURIComponent(email)}`)
  return res.data
}

export const validateInvitation = async (
  token: string
): Promise<{
  valid: boolean
  email?: string
  organization?: string
  role?: string
  expired: boolean
  message?: string
}> => {
  const res = await http.get(`/invitations/validate/${token}`)
  return res.data
}

export const acceptInvitation = async (token: string): Promise<{ success: boolean; message: string }> => {
  const res = await http.post(`/invitations/accept`, { token })
  return res.data
}

export const rejectInvitation = async (token: string): Promise<{ success: boolean; message: string }> => {
  const res = await http.post(`/invitations/reject`, { token })
  return res.data
}

export const removeTeamMember = async (memberId: string): Promise<{ success: boolean; message: string }> => {
  const res = await http.delete(`/teams/${memberId}`)
  return res.data
}
